export class PersonaFisica{

    constructor(){
        this.Identificacion = "";
        this.Nombre = "";
    }

    Identificacion: string;
    Nombre: string;
}